import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const Reports = lazy(() => import("@/pages/Reports"));

export const Route = createFileRoute("/rapporter/")({
  head: () => seoHead("/rapporter"),
  component: () => <Reports />,
});
